import { motion } from "framer-motion";
import { useTheme } from "@/hooks/use-theme";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <motion.button
      onClick={toggleTheme}
      className="p-2 rounded-full glass-effect hover:bg-opacity-20 transition-all duration-300 hover-cursor"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
    >
      <motion.div
        animate={{ rotate: theme === "dark" ? 180 : 0 }}
        transition={{ duration: 0.3 }}
      >
        {theme === "dark" ? (
          <i className="fas fa-sun text-yellow-400 text-xl"></i>
        ) : (
          <i className="fas fa-moon text-primary dark:text-white text-xl"></i>
        )}
      </motion.div>
    </motion.button>
  );
}